export default __webpack_public_path__ + "static/media/art_image3.831ee8d8.jpg";